import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-install-instructions',
  templateUrl: './install-instructions.component.html',
  styleUrls: ['./install-instructions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstallInstructionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
